import 'remixicon/fonts/remixicon.css';

interface ResultHeadersProps {
    type: String,
}

function ResultHeaders(props: ResultHeadersProps): JSX.Element {
    let headerRow: JSX.Element = <></>;

    switch (props.type) {
        case "find-error": {
            headerRow = (
                <div className="border-t border-teal-200 pt-2 mt-4">
                    <h2 className="text-xl text-gray-500 font-bold text-center p-2">Tehtävätyyppi: Etsi virhe</h2>
                    <div className="grid grid-cols-5">
                        <label className="col-span-2 text-l sm:text-xl text-teal-500">Kysymys</label>
                        <label className="text-l sm:text-xl text-teal-500 ml-5">Vastaus</label>
                        <label className="text-xl text-teal-500 text-center">
                            <span className="ri-check-line text-green-500" key={"correcsymbol"}></span>
                            <span className="ri-close-line text-red-500" key={"falsesymbol"}></span>
                        </label>
                        <label className="text-l sm:text-xl text-teal-500 text-center">Aika</label>
                    </div>
                </div >);
            break;
        }
        case "video-recording": {
            headerRow = (
                <div className="border-t border-teal-200 pt-2 mt-4">
                    <h2 className="text-xl text-gray-500 font-bold text-center p-2">Tehtävätyyppi: Katsotaan video</h2>
                    <div className="grid grid-cols-3">
                        <label className="text-xl text-teal-500">Tehtävä</label>
                        <label className="text-xl text-teal-500 text-center">Latauslinkki</label>
                        <label className="text-xl text-teal-500 text-center">Katso video</label>
                    </div>
                </div>
            );
            break;
        }
        case "video-instruction": {
            headerRow = (
                <div className="border-t border-teal-200 pt-2 mt-4">
                    <h2 className="text-xl text-gray-500 font-bold text-center p-2">Tehtävätyyppi: Katsotaan video</h2>
                    <div className="grid grid-cols-5">
                        <label className="col-span-4 text-l sm:text-xl text-teal-500">Tehtävä</label>
                        <label className="text-l sm:text-xl text-teal-500 text-center">Aika</label>
                    </div>
                </div >);
            break;
        }
        case "one-choice": {
            headerRow = (
                <div className="border-t border-teal-200 pt-2 mt-4">
                    <h2 className="text-xl text-gray-500 font-bold text-center p-2">Tehtävätyyppi: Valintatehtävä</h2>
                    <div className="grid grid-cols-6">
                        <label className="col-span-2 text-xl text-teal-500">Kysymys</label>
                        <label className="text-xl text-teal-500 ml-5">Vastaus</label>
                        <label className="text-xl text-teal-500 ml-5">Oikea</label>
                        <label className="text-xl text-teal-500 ml-5">
                            <span className="ri-check-line text-green-500" key={"correctsymbol"}></span>
                            <span className="ri-close-line text-red-500" key={"falsesymbol"}></span>
                        </label>
                        <label className="text-xl text-teal-500 ml-5">Aika</label>
                    </div>
                </div>);
            break;
        }
        case "organize": {
            headerRow = (
                <div className="border-t border-teal-200 pt-2 mt-4">
                    <h2 className="text-xl text-gray-500 font-bold text-center p-2">Tehtävätyyppi: Järjestämistehtävä</h2>
                    <div className="grid grid-cols-5">
                        <label className="col-span-2 text-xl text-teal-500">Vastaus</label>
                        <label className="col-span-2 text-xl text-teal-500 ml-5">Oikea järjestys</label>
                        <label className="text-xl text-teal-500 ml-10">Aika</label>
                    </div>
                </div>);
            break;
        }
        case "combine": {
            headerRow = (
                <div className="border-t border-teal-200 pt-2 mt-4">
                    <h2 className="text-xl text-gray-500 font-bold text-center p-2">Tehtävätyyppi: Yhdistämistehtävä</h2>
                    <div className="grid grid-cols-2">
                        <label className="text-xl text-teal-500">Vastaus</label>
                        <label className="text-xl text-teal-500 ml-10 pl-5">Aika</label>
                    </div>
                </div>);
            break;
        }
        case "memory-game": {
            headerRow = (
                <div className="border-t border-teal-200 pt-2 mt-4">
                    <h2 className="text-xl text-gray-500 font-bold text-center p-2">Tehtävätyyppi: Muistipeli</h2>
                    <div className="grid grid-cols-6">
                        <label className="col-span-2 text-xl text-teal-500">Peli</label>
                        <label className="text-xl text-teal-500">Taso</label>
                        <label className="text-xl text-teal-500">Pareja</label>
                        <label className="text-xl text-teal-500 ml-5">Siirtoja</label>
                        <label className="text-xl text-teal-500 ml-10">Aika</label>
                    </div>
                </div>);
            break;
        }
        case "NONE": {
            break;
        }
        default: {
            break;
        }
    }
    return headerRow;
}

export default ResultHeaders;